import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Text from '../Text/Text';

import classes from './Checkbox.module.scss';

const Checkbox = ({ value, onChange, checked, disabledMode }) => (
  <label className={classes.box}>
    <span
      className={cn(
        classes.checkBox,
        checked && classes.checkBox_selected,
        disabledMode && checked && classes.checkBox_disabled
      )}
    />
    <input
      type="checkbox"
      value={value}
      onChange={onChange}
      checked={checked}
      className={classes.visually_hidden}
    />
    <Text size={4}>{value}</Text>
  </label>
);

Checkbox.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  disabledMode: PropTypes.bool.isRequired
};

export default Checkbox;
